import React, { Component } from 'react';
import moment from 'moment';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import FirstPageInwardOutward from '../../components/despatch/InwardOutward/FirstPageInwardOutward.js';
import SecondPageInwardOutward from '../../components/despatch/InwardOutward/SecondPageInwardOutward.js';
import DespatchServices from '../../services/axioServices/apiServices/DespatchServices.js';


class OutwardPostEntry extends Component {
    constructor(props) {
        super(props);
        this.despatchServices = new DespatchServices();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.state = {
            isGridView: true,
            isLoading: false,
            tableStatus: "",
            partyDropdownList: [],
            outwardPostList: [],
            isEditing: false,
            filterDetails: {
                partyName: "",
                arrangedBy: "date",

            },
            postDetails: {
                date: "",
                courier: "",
                partyId: "",
                podNo: "",
                narration: "",

            },
            arrangedByList: [
                { arrangedBy: "Date", value: "date" },
                { arrangedBy: "Party Name", value: "partyName" },
                { arrangedBy: "Courier Name", value: "courier" },
                { arrangedBy: "P.O.D No.", value: "podNo" },
            ],
            courierList: [
                { courier: "DTDC", value: "dtdc" },
                { courier: "MADHUR", value: "madhur" },
                { courier: "SPEED POST", value: "speedPost" },
                { courier: "TRACKON", value: "trackOn" },
                { courier: "OTHER", value: "other" },
            ],
            validationRules: {
                date: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
                courier: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "courier"
                        ),
                    },
                ],
                podNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "p.o.d no."
                        ),
                    },
                ],
                partyId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "party name"
                        ),
                    },
                ],

            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }
    componentDidMount() {
        this.getAllOutwardPost()
    }
    getAllOutwardPost = () => {
        this.setState({ tableStatus: "Loading..." })
        let request = this.state.filterDetails
        this.despatchServices.getAllOutwardPost(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                if (response.responseData.length === 0) {
                    this.setState({ tableStatus: "No Record Found" })
                } else {
                    this.setState({ tableStatus: "" })
                }
                this.setState(
                    { outwardPostList: response.responseData }, () => {
                        this.getAllPartyDropdown()
                    });
            } else {
                this.setState({ tableStatus: "" })
                this.getAllPartyDropdown();
                this.SwalServices.Error(response.Message);
            }
        });
    };

    addEditOutwardPost = () => {
        let isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            this.setState({ isLoading: true }, () => {
                let request = this.state.postDetails;
                if (this.state._id && this.state._id !== "") {
                    request._id = this.state._id;
                } else {
                    delete request._id;
                }
                this.despatchServices.addEditOutwardPost(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        this.SwalServices.Success(response.Message);
                        this.getAllOutwardPost();
                        this.setState({ isLoading: false })
                        this.openGridView();
                    } else {
                        this.setState({ isLoading: false })
                        this.SwalServices.Error(response.Message);
                    }
                });
            })
        }
    }
    getOutwardPostById = (id) => {
        this.despatchServices.getOutwardPostById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let details = this.state.postDetails
                details.date = moment(response.responseData.date).format("yyyy-MM-DD")
                details.courier = response.responseData.courier
                details.narration = response.responseData.narration
                details.partyId = response.responseData.partyId
                details.podNo = response.responseData.podNo
                this.setState({ postDetails: details, _id: response.responseData._id }, () => {
                    this.setState({ isEditing: true, isGridView: false });
                });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };
    deleteOutwardPostById = (id) => {
        this.despatchServices.deleteOutwardPostById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                this.SwalServices.Success(response.Message);
                this.resetForm();
                this.getAllOutwardPost();
            } else {
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };
    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                    email: item.email,
                }));
                this.setState({ partyDropdownList: dropdownItems });
            } else {
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.postDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    closeGridView = () => {
        this.setState({ isGridView: false });
    };

    openGridView = () => {
        this.resetForm();
        this.setState({ isGridView: true, isEditing: false });
    };


    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}

        let filterDetails = this.state.filterDetails
        filterDetails.partyName = ""
        filterDetails.arrangedBy = ""

        let postDetails = this.state.postDetails
        postDetails.date = ""
        postDetails.courier = ""
        postDetails.partyId = ""
        postDetails.podNo = ""
        postDetails.narration = ""

        this.setState({ filterDetails: filterDetails, postDetails: postDetails, validState: validState }, () => {
            this.getAllOutwardPost()
        }
        );
    }
    handleChange = (event, name, section) => {
        let value = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = value.toUpperCase();
            this.setState({ filterDetails: details }, () => {
                this.getAllOutwardPost()
            })
        }
        else if (section === "postDetails") {
            let details = this.state.postDetails;
            details[name] = value.toUpperCase();
            if (name === 'freight' || name === 'other' || name === 'roundOff') {
                this.calculateGrandTotal()
            }
            this.setState({ postDetails: details });
        }
    };
    handleDropDownChange = (event, name, section) => {
        const select = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = select;
            this.setState({ filterDetails: details }, () => {
                this.getAllOutwardPost()
            })
        }
        else if (section === "postDetails") {
            let details = this.state.postDetails;
            details[name] = select;
            this.setState({ postDetails: details });
        }
    };
    setFilterParameters = (selected, drpIdentity, section) => {
        let details = this.state.postDetails;
        details[drpIdentity] = selected.value;
        this.setState({ postDetails: details });
    };
    render() {
        return (
            <div className='InwardPostEntry-page'>
                {/* First Page  */}
                {this.state.isGridView === true ? (
                    <FirstPageInwardOutward
                        filterDetails={this.state.filterDetails}
                        arrangedByList={this.state.arrangedByList}
                        handleChange={this.handleChange.bind(this)}
                        handleDropDownChange={this.handleDropDownChange.bind(this)}
                        closeGridView={this.closeGridView.bind(this)}
                        PostList={this.state.outwardPostList}
                        noItemFound={this.state.noItemFound}
                        getPostById={this.getOutwardPostById.bind(this)}
                        deletePostById={this.deleteOutwardPostById.bind(this)}
                        tableStatus={this.state.tableStatus} />

                ) : null}

                {/* Second Page  */}
                {this.state.isGridView === false ? (
                    <SecondPageInwardOutward
                        postDetails={this.state.postDetails}
                        handleChange={this.handleChange.bind(this)}
                        handleDropDownChange={this.handleDropDownChange.bind(this)}
                        courierList={this.state.courierList}
                        setFilterParameters={this.setFilterParameters.bind(this)}
                        partyDropdownList={this.state.partyDropdownList}
                        openGridView={this.openGridView.bind(this)}
                        validationRules={this.state.validationRules}
                        validState={this.state.validState}
                        addEditPost={this.addEditOutwardPost.bind(this)}
                        resetForm={this.resetForm.bind(this)}
                        isEditing={this.state.isEditing}
                        isLoading={this.state.isLoading}
                    />
                ) : null}
            </div>
        );
    }
}

export default OutwardPostEntry;